/**
 * @module features/inquiries
 */

export { default as reducer } from './reducer'

export { loadInquiry, loadAnswer, setInquiryStatus } from './actions'
export { requestInquiry } from './dispatchers'

export * from './types'
